import { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';

/**
 * Polls /api/community/unread-count every 60s for the signed-in user.
 * Returns { count, refresh, markSeen } so callers can render a badge
 * and reset the count when the user opens the community feed.
 */
export const useCommunityUnread = () => {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const res = await api.get('/community/unread-count');
      setCount(res.data?.unread_count || 0);
    } catch { /* silent */ }
  }, [user]);

  const markSeen = useCallback(async () => {
    if (!user) return;
    try {
      await api.post('/community/mark-seen');
      setCount(0);
    } catch { /* silent */ }
  }, [user]);

  useEffect(() => {
    if (!user) return undefined;
    refresh();
    const interval = setInterval(refresh, 60000);
    return () => clearInterval(interval);
  }, [user, refresh]);

  return { count, refresh, markSeen };
};
